module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_0.2b63fb75.png";